<template>

  <div class="keyboard-base">
  	
  	<KeyboardKey v-for="key, index in keys" :key="index" :value="key" />

  </div>

</template>

<script>

import KeyboardKey from '@/components/KeyboardKey'
import mappedKeys from '@/data/mapped-keys.json'

export default {

  name: 'Keyboard',

  components: {
  	KeyboardKey,
  },

  data() {

    return {
    	keys: mappedKeys,
    }
  },

  computed: {

  },

  methods: {
  },
}
</script>

<style lang="css" scoped>
.keyboard-base {
  max-width: 1085px;
  padding: 20px;
  position: relative;
  margin: auto;
  margin-top: 40px;
  /*top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);*/
  background-color: #f3eee5;
  border-radius: 10px;
  display: grid;
  grid-template-columns: repeat(30, 30px);
  grid-template-rows: repeat(5, 60px);
  grid-gap: 5px;
}
</style>